<template>
  <nav
    class="navbar navbar-color-on-scroll fixed-top navbar-expand-lg"
    v-bind:class="{ 'navbar-transparent': mainPage}"
    color-on-scroll="100"
    v-scroll="handleScroll"
    id="sectionsNav"
  >
    <div class="container">
      <div class="navbar-translate">
        <a class="navbar-brand" href="http://szybkiewypo.pl">Szybkie Wypo</a>
      </div>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              class="nav-link"
              rel="tooltip"
              title="Kiedy złożyć wypowiedzenie? - Szybkiewypo.pl"
              data-placement="bottom"
              href="/kiedy-zlozyc-wypowiedzenie"
            >
              Kiedy złożyc wypowiedzenie?
            </a>
          </li>
        </ul>

        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a
              class="nav-link"
              rel="tooltip"
              title="Linked xD - generator wiadomości HR"
              data-placement="bottom"
              href="http://devpurge.com/linkedxd"
              target="_blank"
            >
              Linked xD - generator wiadomości HR
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              rel="nofollow"
              title
              data-placement="bottom"
              href="https://www.facebook.com/szybkiewypo/"
              target="_blank"
              data-original-title="Like us on Facebook"
            >
              <i class="fa fa-facebook-square"></i>
            </a>
          </li>
          <li class="nav-item">
                {{$t('ui.langSelector')}}:
                <select  v-model="$i18n.locale">
          <option
            v-for="(lang, i) in langs"
            :key="`lang-${i}`"
            :value="lang"
          >
            {{ lang }}
          </option>
        </select>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import jQuery from "jquery";

export default {
  name: "Navbar",
  props: {
    mainPage: Boolean,    
  },
  data: function () {
    return {
      transparent: true,
      langs: ['pl', 'ua']
    };
  },
  methods: {
    handleScroll: function () {
      if (this.mainPage) {
        this.checkScrollForTransparentNavbar();
      }
    },
    checkScrollForTransparentNavbar: debounce(function () {
      if (jQuery(document).scrollTop() > 100) {
        if (this.transparent) {
          this.transparent = false;
          jQuery(".navbar-color-on-scroll").removeClass("navbar-transparent");
        }
      } else {
        if (!this.transparent) {
          this.transparent = true;
          jQuery(".navbar-color-on-scroll").addClass("navbar-transparent");
        }
      }
    }, 17),
  },
  created: function () {
    
    if (this.mainPage) {
      this.checkScrollForTransparentNavbar();
    }
  },
};

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar .navbar-nav .nav-item .nav-link {
  text-transform: none;
}

.badge-custom {
  text-transform: none;
  font-weight: bold;;
}
</style>
